import type { ServerResponse } from "@/http"
import type { IEventTemplateResponse } from "@/types"
import { axios } from "@/axios"
import { EventTemplate } from "@/models"

/**
 * Retrieves details of a custom event template.
 *
 * @param {number} [customTemplateID] - The ID of the custom template to fetch.
 * @throws {Error} If `customTemplateID` is not provided.
 * @returns {Promise<EventTemplate>} The retrieved event template details.
 */
export async function getCustomTemplate(customTemplateID?: number): Promise<EventTemplate> {
  if (!customTemplateID) {
    throw new Error(
      "Missing `customTemplateID` when attempting to get extend template details. Please ensure `customTemplateID` is provided.",
    )
  }

  const response = await axios.get<ServerResponse<IEventTemplateResponse>>(`api/template/${customTemplateID}`)

  return EventTemplate.fromResponse(response.data?.Data)
}
